import React, { useState, useEffect} from 'react'; 
import DataTable from "react-data-table-component";
import "./styles.css";
import moment from 'moment';
import SRQService from '../../Services/SRQService';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {Popover} from 'react-bootstrap'
const ViewServiceRequest = () => {
   
    const customStyles = {
        header: {
            style: {
                minHeight: '140px',
                color: '#2d32aa',
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                background: '#f6f7f9',
                fontSize: '32px',
                textAlign: 'left',
                fontWeight: '600px',
            },
        },
        headRow: {
            style: {
                background: '#2d32aa',
                color: '#fff',
                padding: '14px ​12px',
                borderRadius: 0,
                fontWeight: 'normal',
                borderTop: '1.5px solid #3e6a85',
                borderBottom: '1.5px solid #3e6a85',
                borderLeft: 'none',
                minWidth: '120px',
                fontSize: '14.1px',
            },
        },
        headCells: {

            style: {
                '&:not(:last-of-type)': {
                },
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    //paddingBottom: '10px',
                    color: '#000',
                      textAlign: 'left',
                      padding: '14px ​12px',
                      opacity: '21',
                      fontSize: '13px',
                },
            },
        },
    };
    const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erroressage, setErrorMessage] = useState('');
    useEffect(() => {
    fetchServiceRequests(); 
    
  }, []);

const fetchServiceRequests = async() => {
  setLoading(true);
  await SRQService.getAllServiceRequests()
    .then((response) => {
      if(response.data.code === 'APIM-7013') {
        setErrorMessage(response.data.message);
        setData([]); // Clear the data if there is an error
      } else {
        setData(response.data);
        setErrorMessage(''); // Clear the error message if there is no error
      }
    })
    .catch(error => {
      setErrorMessage(error.message);
      setData([]); // Clear the data if there is an error
    })
    .finally(() => {
      setLoading(false);
    });
};

    return (
      <div className="view-service-request-page">
    <div className="vsr-header">
      <h2>VIEW SERVICE REQUESTS</h2>
    </div>
    <div className="table-container">
      {
          erroressage && erroressage !== '' ? (
            <DataTable
              title="VIEW SERVICE REQUESTS"
              customStyles={customStyles}
              noDataComponent={
                <div style={{ minHeight: '450px', display: 'flex', alignItems: 'left', marginLeft:'10px', justifyContent: 'left' }}>
                  {erroressage}
                </div>
              }
              style={{ minHeight: '450px' }}
            />
          ) : (
            <DataTable
              title="VIEW SERVICE REQUESTS"
              columns={columns}
              data={data}
              noHeader
              paginationComponent={BootyPagination}
              highlightOnHover={true}
              customStyles={customStyles}
              progressPending={loading}
              sortFunction={customSort}
              defaultSortFieldId={5}
              pagination
              style={{ minHeight: '450px' }}
              noDataComponent={
                <div style={{ minHeight: '450px', display: 'flex', alignItems: 'left',  marginLeft:'10px', justifyContent: 'left' }}>
                  No Service Requests Found
                </div>
              }
            />
          )
        }
    </div>
  </div>
    );
    
} 

const customSort = (rows, selector, direction) => {
  return rows.sort((a, b) => {
    const aField = selector(a);
    const bField = selector(b);

    let comparison = 0;

    if (aField > bField) {
      comparison = 1;
    } else if (aField < bField) {
      comparison = -1;
    }

    return direction === 'asc' ? comparison * -1 : comparison;
  });
};




function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];

  for (let i = 1; i < pages+1; i++) {
    results.push(i);
  }

  return results;
}
const popover = (data) =>(  
  
  <Popover id={`popover-positioned-bottom`}>  
          <Popover.Header as="h5"></Popover.Header>  
          <Popover.Body style={{color:'#a2a2a2'}}>  
            {data}  
          </Popover.Body>  
        </Popover> 
); 

const columns = [
  {
    name: <span className="vsr-table-header">Request Id</span>,
    selector: row => row.requestNumber,
    sortable: true,
    wrap: true,
    minWidth: "170px",
    cell: row => {
      let rq = row.requestNumber;
      if (!rq || rq === 'null') {
        return <span className="vsr-table-cell">-</span>;
      } else {
        return (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={popover(row.summary)}
          >
            <span className="vsr-table-cell">{row.requestNumber}</span>
          </OverlayTrigger>
        );
      }
    }
  },
  {
    name: <span className="vsr-table-header">Company Name</span>,
    selector: row => row.company,
    sortable: true,
    wrap: true,
    minWidth: "220px",
    cell: row => <span className="vsr-table-cell">{row.company || '-'}</span>
  },
  {
    name: <span className="vsr-table-header">Project Name</span>,
    selector: row => row.project,
    sortable: true,
    wrap: true,
    minWidth: "230px",
    cell: row => <span className="vsr-table-cell">{row.project || '-'}</span>
  },
  {
    name: <span className="vsr-table-header">Request Type</span>,
    selector: row => row.type,
    sortable: true,
    wrap: true,
    minWidth: "200px",
    cell: row => <span className="vsr-table-cell">{row.type || '-'}</span>
  },
  {
    name: <span className="vsr-table-header">Request Date</span>,
    selector: row => row.createdDate,
    sortable: true,
    wrap: true,
    minWidth: "200px",
    cell: row => <span className="vsr-table-cell">{row.createdDate || '-'}</span>
  },
  {
    name: <span className="vsr-table-header">Request Status</span>,
    selector: row => row.status,
    sortable: true,
    wrap: true,
    minWidth: "180px",
    cell: row => <span className="vsr-table-cell">{row.status || '-'}</span>,
    conditionalCellStyles: [
      {
        when: row => row.status === 'New',
        style: {
          color: 'blue',
          '&:hover': {
            cursor: 'pointer',
          },
          textAlign: 'left',
        },
      },
      {
        when: row => row.status === 'Failed' || row.status === 'Closed Incomplete',
        style: {
          color: 'red',
          '&:hover': {
            cursor: 'pointer',
          },
          textAlign: 'left',
        },
      },
      {
        when: row => row.status === 'Closed Skipped',
        style: {
          color: 'green',
          '&:hover': {
            cursor: 'pointer',
          },
          textAlign: 'left',
        },
      },
    ],
  },
];

// RDT exposes the following internal pagination properties
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };
//alert('-rowCount--'+rowCount);
  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  //alert('-pageItems--'+pageItems);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <div>
    {rowCount>=10?
      <nav>
      <ul className="pagination justify-content-end pagination-large m-3 me-0">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {
          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
      :<></>}
      </div>
      );
};




export default ViewServiceRequest;